// extracted by mini-css-extract-plugin
module.exports = {"root":"index-module--root--3Yzn2","overlay":"index-module--overlay--17rQB","text":"index-module--text--1MCUN","zh":"index-module--zh--M4jIL"};